export default __webpack_public_path__ + "static/media/bg.d199e3f7.png";